import get from "lodash/get";

export const getDocumentUploadFile = state => get(state, "uploadDocument.file");
export const getDocumentUploadIsUploading = state => get(state, "uploadDocument.isUploading");
export const getDocumentUploadProgress = state => get(state, "uploadDocument.progress");
export const getDocumentUploadUploadFinished = state => get(state, "uploadDocument.uploaded");
export const getDocumentUploadError = state => get(state, "uploadDocument.error");
export const getDocumentUploadResponse = state => get(state, "uploadDocument.uploadResponse");
